import { ApolloClient, createNetworkInterface } from 'react-apollo';

const networkInterface = createNetworkInterface({
  uri: process.env.REACT_APP_GRAPH_COOL_SIMPLE,
});

networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {};
      }

      // get the authentication token from local storage if it exists
      if (localStorage.getItem('auth0IdToken')) {
        req.options.headers.authorization = `Bearer ${localStorage.getItem(
          'auth0IdToken'
        )}`;
      }

      next();
    },
  },
]);

const client = new ApolloClient({
  networkInterface,
});

export default client;



// WEBPACK FOOTER //
// ./src/App/apolloClient.js